import React, { useEffect } from "react";
import { Play, Pause, Next, Prev } from "./Icons";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";

import { isFinite } from "lodash";

const MediaControls = ({
  title,
  progress,
  position,
  duration,
  onSeek,
  isPlaying,
  onTogglePlayback,
  canClickPrev,
  onClickPrev,
  canClickNext,
  onClickNext,
  classNames,
  isVideoLoaded,
  children,
}) => {
  const currentTime = () => {
    const padLeft = (str) => str.replace(/^(\d)$/, "0$1");
    const minutes = String(parseInt(position / 60, 10));
    const seconds = String(parseInt(position % 60, 10));

    return (
      isFinite(parseInt(position / 60, 10)) &&
      isFinite(parseInt(position % 60, 10)) &&
      `${padLeft(minutes)}:${padLeft(seconds)}`
    );
  };

  const videoDuration = () => {
    const padLeft = (str) => str.replace(/^(\d)$/, "0$1");
    const minutes = String(parseInt(duration / 60, 10));
    const seconds = String(parseInt(duration % 60, 10));

    return `${padLeft(minutes)}:${padLeft(seconds)}`;
  };

  return (
    <React.Fragment>
      <div className={`media-controls ${classNames}`}>
        {children}
        <div className="media-controls__inner">
          <div className="media-controls__track p1">
            <InputRange
              maxValue={100}
              minValue={0}
              value={progress}
              onChange={onSeek}
            />
            <div className="media-controls__track-info pt1">
              <p>{currentTime(position)}</p>
              <p>{title}</p>
              <p>
                {isVideoLoaded === false ? "Loading" : videoDuration(duration)}
              </p>
            </div>
          </div>
          <div className="media-controls__actions">
            <button
              className="p1 media-controls__button"
              onClick={canClickPrev ? onClickPrev : null}
              disabled={isVideoLoaded === false || !canClickPrev}
              title={isVideoLoaded === false ? "Loading Video" : ""}
            >
              <Prev />
            </button>
            <button
              className="p1 media-controls__button media-controls__button--play-pause"
              onClick={onTogglePlayback}
              disabled={isVideoLoaded === false}
              title={isVideoLoaded === false ? "Loading Video" : ""}
            >
              {isPlaying ? <Pause /> : <Play />}
            </button>
            <button
              className="p1 media-controls__button"
              onClick={canClickNext ? onClickNext : null}
              disabled={isVideoLoaded === false || !canClickNext}
              title={isVideoLoaded === false ? "Loading Video" : ""}
            >
              <Next />
            </button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default MediaControls;
